// extracted by mini-css-extract-plugin
export default {"embla":"ChangeTariff_embla__eijeM","emblaContainer":"ChangeTariff_emblaContainer__3jS-I","emblaSlide":"ChangeTariff_emblaSlide__jLXiP"};